/*
 * Desktop PDP buy box compaction for the Skio plan picker.
 * The picker renders inside a shadow root, so theme CSS cannot reach it.
 * This adds a small stylesheet inside it (desktop only):
 *   - all subscription frequencies on one row instead of stacked
 *   - slightly tighter padding in the subscription box
 * Loaded on product pages from layout/theme.liquid. Remove that include to undo.
 */
(function () {
  var CSS = [
    '@media (min-width: 768px) {',
    '  :host .group-content { padding: 14px 22px; gap: 4px; }',
    '  :host .group-content ul li span { line-height: 20px; }',
    '  :host .selling-plan-buttons { flex-direction: row; gap: 6px; margin-top: 4px; }',
    '  :host .default-selling-plan, :host .other-selling-plan-container, :host .other-selling-plan { display: contents; }',
    '  :host .selling-plan-buttons label,',
    "  :host .selling-plan-buttons input[type='radio']:checked + label {",
    '    flex: 1 1 0; width: auto; min-height: 44px; margin: 0; padding: 6px 8px;',
    '    font-size: 12px; line-height: 1.25; box-sizing: border-box;',
    '  }',
    '}'
  ].join('\n');

  // Desktop only: drop the " - Recommended" suffix Skio adds to the default plan,
  // so it fits in the one-row layout. The default plan is still pre-selected.
  var desktop = window.matchMedia('(min-width: 768px)');
  var SUFFIX = /\s*-\s*Recommended/;

  function stripRecommended(root) {
    if (!desktop.matches) return;
    root.querySelectorAll('.selling-plan-buttons label').forEach(function (label) {
      var walker = document.createTreeWalker(label, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        if (SUFFIX.test(node.data)) node.data = node.data.replace(SUFFIX, '');
      }
    });
  }

  function apply(el) {
    var root = el.shadowRoot;
    if (!root || el.__pdpCompact) return;
    el.__pdpCompact = true;
    try {
      var sheet = new CSSStyleSheet();
      sheet.replaceSync(CSS);
      root.adoptedStyleSheets = root.adoptedStyleSheets.concat([sheet]);
    } catch (e) {
      var style = document.createElement('style');
      style.textContent = CSS;
      root.appendChild(style);
    }
    stripRecommended(root);
    // Skio re-renders when the variant or plan changes; strip again after each render.
    new MutationObserver(function () { stripRecommended(root); })
      .observe(root, { subtree: true, childList: true, characterData: true });
  }

  function run() {
    document.querySelectorAll('skio-plan-picker').forEach(function (el) {
      var ready = el.updateComplete;
      if (ready && typeof ready.then === 'function') {
        ready.then(function () { apply(el); });
      } else {
        apply(el);
      }
    });
  }

  if (window.customElements) {
    customElements.whenDefined('skio-plan-picker').then(run);
  }
})();
